import Img1 from "../Images/logo.png";

function Header() {
  return (
    <div className="Backgroundnav pt-2 pb-2">
      <nav class="navbar container header navbar-expand-lg navbar-dark pt-3">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">
            <img className="w-100 logo" src={Img1} />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse pt-2 pr-5"
            id="navbarSupportedContent"
          >
            <ul class="navbar-nav ml-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/">
                  Home
                </a>
              </li>
              <li class="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  NFTARTLINK Auctions
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="nav-link text-dark" href="/view-auctions">
                      Live Auction
                    </a>
                  </li>
                  <a className="nav-link text-dark" href="/past-auctions">
                    Past Auction
                  </a>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Community Auctions
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a
                      className="nav-link text-dark"
                      href="/community-auctions"
                    >
                      Live Auction
                    </a>
                  </li>
                  <a
                    className="nav-link text-dark"
                    href="/past-community-auctions"
                  >
                    Past Auction
                  </a>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Dashboard
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <a className="nav-link text-dark" href="/createauction">
                      Create Auction
                    </a>
                  </li>
                  <li>
                    <a className="nav-link text-dark" href="/updateauction">
                      Update Auction
                    </a>
                  </li>
                  <li>
                    <a className="nav-link text-dark" href="/claim">
                      Claim NFT
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
